import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from '@react-google-maps/api';
import Promise from 'bluebird';
import _ from 'lodash';
import { markerIcons } from '../../app/google_maps';
import UrlHelper from '../../app/url_helper';
import Draggable from '../draggable';

export default class AddressMarker extends Component {
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  onDragStart() {
    // Disable overflow
    _.forEach($(this.img).parents(), (div) => {
      $(div).css('overflow', 'visible');
      return !$(div).hasClass('si-content-wrapper');
    });
  }

  onDragEnd(e, object) {
    const { overlayView, stops, schools, stopKinds } = this.props;
    const position = Draggable.latLng(e, overlayView, $('#map-network-manage').offset());
    const stop = _(stops)
      .filter(s => _.includes(stopKinds, s.kind))
      .find(s => google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(s), position) < 200);
    const school = _.find(schools, s => google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(s), position) < 200);
    if (!stop && !school) { return; }

    const stoppableId = (stop && stop.id) || (school && school.id);
    const stoppableType = stop ? 'Stop' : 'School';
    const address = _.find(object.addresses, { full_address: this.props.address.fullAddress });

    // Assign address to this stoppable
    Promise.resolve($.ajax({
      url: UrlHelper.networkScopedUrl(`/plans/${this.props.planId}/addresses/${address.id}`),
      data: { stoppable_id: stoppableId, stoppable_type: stoppableType },
      dataType: 'script',
      method: 'PUT',
    })).catchReturn();
  }

  markerKind(address) {
    const { stoppableAddresses } = this.props;
    const stoppableAddress = _.find(stoppableAddresses, { address_id: address.id, stoppable_type: 'School' });
    if (stoppableAddress) { return 'school'; }
    return this.stopKind(address);
  }

  stopKind(address) {
    const { stoppableAddresses, stops } = this.props;
    const stop = _.find(stops, {
      id: _.get(_.find(stoppableAddresses, { address_id: address.id, stoppable_type: 'Stop' }), 'stoppable_id'),
    });
    return stop && stop.kind;
  }

  stopKinds() {
    const { address } = this.props;
    return _(address.students).map(s => _.find(s.addresses, { full_address: address.fullAddress }))
      .compact()
      .map(a => this.markerKind(a))
      .uniq()
      .value();
  }

  icon() {
    const stopKinds = this.stopKinds();
    if (stopKinds.length > 1) {
      return markerIcons.pinBlue;
    } else if (stopKinds.length === 0) {
      return markerIcons.pinGrey;
    }
    return {
      scholar: markerIcons.pinOrange,
      public_transport: markerIcons.pinGreen,
      school: markerIcons.pinPurple,
    }[stopKinds[0]] || markerIcons.pinGrey;
  }

  render() {
    const { address, onClick, selected } = this.props;
    const infoWindow = selected && this.props.planId ? (
      <InfoWindow>
        <div className="info-students">
          {address.students.map(s => (
            <div className="student-row" key={s.id}>
              <Draggable
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStart}
                object={s}
              >
                <img alt={s.display_name} id={`popover-student-${s.id}`} src={s.photo || markerIcons.studentPlaceholder} ref={(img) => { this.img = img; }} />
              </Draggable>
              <span>{s.display_name}</span>
            </div>
          ))}
        </div>
      </InfoWindow>
    ) : null;
    return (
      <Marker
        key={address.id}
        position={{
          lat: address.location.lat,
          lng: address.location.lng,
        }}
        icon={this.icon()}
        clickable
        onClick={() => { onClick(address); }}
      >
        {infoWindow}
      </Marker>
    );
  }
}

AddressMarker.defaultProps = {
  overlayView: null,
  planId: null,
  stopKinds: null,
};

AddressMarker.propTypes = {
  planId: PropTypes.number,
  address: PropTypes.shape({
    id: PropTypes.number.isRequired,
    location: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }),
    students: PropTypes.arrayOf(PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      photo: PropTypes.string,
    })).isRequired,
    fullAddress: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  overlayView: PropTypes.instanceOf(google.maps.OverlayView),
  stops: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  })).isRequired,
  stopKinds: PropTypes.arrayOf(PropTypes.string),
  stoppableAddresses: PropTypes.arrayOf(PropTypes.shape({
    stoppable_id: PropTypes.number.isRequired,
    stoppable_type: PropTypes.oneOf(['Stop', 'School']).isRequired,
    address_id: PropTypes.number.isRequired,
  })).isRequired,
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    region: PropTypes.string.isRequired,
    radius: PropTypes.number,
    polygon: PropTypes.shape({
      paths: PropTypes.arrayOf(PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
      })),
    }),
  })).isRequired,
};
